import api from './client';

// ── Capital Structure API ─────────────────────────────────

export const capitalStructureApi = {
  // Core metrics
  summary: () => api.get('/capital-structure/summary'),
  trajectory: (horizon?: number) =>
    api.get('/capital-structure/trajectory', { params: { horizon } }),
  debtSchedule: () => api.get('/capital-structure/debt-schedule'),

  // Maturity & rate
  maturityProfile: () => api.get('/capital-structure/maturity-profile'),
  rateExposure: () => api.get('/capital-structure/rate-exposure'),

  // Covenants
  covenants: () => api.get('/capital-structure/covenants'),
  createCovenant: (data: {
    liabilityId: string;
    name: string;
    covenantType: string;
    thresholdValue: number;
    thresholdDisplay: string;
    watchThresholdPct?: number;
    testFrequency?: string;
    notes?: string;
  }) => api.post('/capital-structure/covenants', data),
  updateCovenant: (id: string, data: any) =>
    api.put(`/capital-structure/covenants/${id}`, data),
  deleteCovenant: (id: string) =>
    api.delete(`/capital-structure/covenants/${id}`),

  // Contribution scenarios
  modelScenario: (data: {
    entityId: string;
    contributorMemberId: string;
    amount: number;
    structure: 'dilution' | 'preferred_equity' | 'member_loan';
  }) => api.post('/capital-structure/scenarios', data),
  listScenarios: () => api.get('/capital-structure/scenarios'),
  saveScenario: (data: any) => api.post('/capital-structure/scenarios/save', data),

  // Stress testing
  stressTest: (bps?: number) =>
    api.get('/capital-structure/stress-test', { params: { bps } }),

  // Snapshots
  saveSnapshot: () => api.post('/capital-structure/snapshot'),
  getSnapshots: (limit?: number) =>
    api.get('/capital-structure/snapshots', { params: { limit } }),
};
